/* 
 * CALS Masonry functionality
 * http://masonry.desandro.com/ + http://imagesloaded.desandro.com/
 */

// imports need to be required due to AMD
// import { imagesLoaded } from 'imagesloaded';
// tslint:disable-next-line:no-var-requires
const imagesLoaded = require('imagesloaded');
// import { Masonry as MasonryLayout } from 'masonry-layout';
// import Masonry from 'masonry-layout';
// tslint:disable-next-line:no-var-requires
const MasonryLayout = require('masonry-layout');


declare var log, info, warn, groupCollapsed, groupEnd;

export class Masonry {

  private showLogs = false;

  private defaults = {
    sel: '.tip-images'
  };

  public makeMasonry(sel, itemSel?, colWidth?) {

    //if args are undefined, set to the default (tips)
    sel = sel || '.tip-images';
    itemSel = itemSel || '.tip-img';
    colWidth = colWidth || 370;

    let showLogs = this.showLogs;

    if (showLogs) { info("makeMasonry (sel: '%s', itemSel: '%s' length: %d", sel, itemSel, $(sel).length); }

    if ($(sel).length) {

      $(sel).each(function () {
        if (showLogs) { info("makeMasonry each thisWrap :", this); }//, $(this)
        let thisWrap = this;//$(this);
        let mason = new MasonryLayout(thisWrap, {
          // options
          itemSelector: itemSel,//'.tip-img',
          columnWidth: colWidth
        });
        let imgLoad = imagesLoaded(thisWrap);
        // function onAlways( instance ) {
        //     console.log('all images are loaded');
        // }
        // // bind with .on()
        // imgLoad.on( 'always', onAlways );
        // // unbind with .off()
        // imgLoad.off( 'always', onAlways );

        imgLoad.on('progress', function (instance, image) {
          // if (showLogs && image && typeof image.isLoaded !== "undefined") {
          //     let result = image.isLoaded ? 'loaded' : 'broken';
          //     info( 'image is %s for %s (( image: %o', result, image.img.src, image);
          // }
          if (image && image.isLoaded && instance && instance.elements && instance.elements.length) {
            if (showLogs) { log("image: %o loaded instance: %o for thisWrap: %o", image, instance, thisWrap); }
            mason.layout();
          } else {
            warn("unable to makeMason - images not loaded correctly - instance: %o", instance);
          }

        });
      });





      // v4

      // let sections = document.querySelectorAll(sel);
      // if (showLogs) { log("sections:",sections); }
      // let imgLoad = ImagesLoaded( sections );

      // imgLoad.on( 'progress', function ( instance, image ) {
      //     // if (showLogs && image && typeof image.isLoaded !== "undefined") {
      //     //     let result = image.isLoaded ? 'loaded' : 'broken';
      //     //     info( 'image is %s for %s (( image: %o', result, image.img.src, image);
      //     // }
      //     if (image && image.isLoaded && instance && instance.elements && instance.elements.length) {
      //         if (showLogs) { log("image: %o loaded instance: %o for sections: %o",image, instance, sections); }
      //         let mason = new Masonry( instance.elements[0], {
      //             // options
      //             itemSelector: itemSel,//'.tip-img',
      //             columnWidth: colWidth
      //         });
      //     } else {
      //         warn("unable to makeMason - images not loaded correctly - instance: %o",instance);
      //     }

      // });




      // $(sel).each(function() {
      //     // init Masonry
      //     let $section = $(sel).masonry({
      //         // options
      //         itemSelector: itemSel,//'.tip-img',
      //         columnWidth: colWidth
      //     });
      //     // layout Masonry after each image loads
      //     $section.imagesLoaded().progress( function() {
      //         $section.masonry('layout');
      //     });

      // });





      //using jquery
      // Use .makeJQueryPlugin to make to use .imagesLoaded() jQuery plugin.
      // ImagesLoaded.makeJQueryPlugin( $ );
      // $('#container').imagesLoaded( function() {...});

      // v3 loop all
      // let makeMason = function (instance) { 
      //     info("images loaded > makeMason instance: %o",instance);
      //     if (instance && instance.elements && instance.elements.length) {
      //         let mason = new Masonry( instance.elements[0], {
      //             // options
      //             itemSelector: itemSel,//'.tip-img',
      //             columnWidth: colWidth
      //         });
      //     } else {
      //         warn("unable to makeMason - images not loaded correctly - instance: %o",instance);
      //     }
      // };

      // $(sel).each(function() {
      //     // let imgLoad = new ImagesLoaded( $(this) );
      //     // imgLoad.on('always', makeMason);
      //     let thisWrap = $(this);
      //     let loader = new ImagesLoaded(  thisWrap, makeMason );
      //     // let loader = new ImagesLoaded(  thisWrap, function (instance) { 
      //     //     info("images loaded",instance, thisWrap);
      //     //     if (instance && instance.elements && instance.elements.length) {
      //     //         new Masonry( instance.elements[0], {
      //     //             // options
      //     //             itemSelector: itemSel,//'.tip-img',
      //     //             columnWidth: colWidth
      //     //         });
      //     //     }

      //     // });
      // });

      // // vanilla - v2
      // var nodes = document.querySelectorAll(sel);
      // //info('nodes',nodes.length,nodes);
      // for (var i = 0; i < nodes.length; ++i) {
      //     var item = nodes[i];  // Calling myNodeList.item(i) isn't necessary in JavaScript
      //     log("loop item",item);
      //     // http://imagesloaded.desandro.com/
      //     var imgLoad = new ImagesLoaded( nodes[i] , function () { 
      //         info("images loaded",nodes[i]);
      //         var msnry = new Masonry( nodes[i], {
      //             // options
      //             itemSelector: itemSel,//'.tip-img',
      //             columnWidth: colWidth
      //         });
      //     });
      // }

      // v1 - vanilla
      // //var elem = document.querySelector(sel);
      // var msnry = new Masonry( sel, {
      //     // options
      //     itemSelector: itemSel,//'.tip-img',
      //     columnWidth: colWidth
      // });
      log("created Masonry for %s , items: %s @ colWidth: %d", sel, itemSel, colWidth);
    } else {
      log("Masonry el not found");
    }
  }

}



